
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-7.748 8A8.015 8.015 0 004 12c0 .69.088 1.36.252 2h2.842a21.013 21.013 0 010-4H4.252zm.818-2h2.323c.212-1.024.505-1.96.865-2.77.06-.136.123-.269.188-.399A8.036 8.036 0 005.07 8zm4.034 2A18.91 18.91 0 009 12c0 .693.037 1.362.104 2h5.792c.067-.638.104-1.307.104-2 0-.693-.037-1.362-.104-2H9.104zm5.454-2H9.442c.173-.732.392-1.392.643-1.958.328-.738.693-1.273 1.047-1.61.35-.333.641-.432.868-.432.227 0 .518.1.868.432.354.337.719.872 1.047 1.61.251.566.47 1.226.643 1.958zm2.348 2a21.027 21.027 0 010 4h2.842c.165-.64.252-1.31.252-2s-.087-1.36-.252-2h-2.842zm2.024-2h-2.323a13.703 13.703 0 00-.865-2.77 9.78 9.78 0 00-.188-.399A8.036 8.036 0 0118.93 8zM8.446 19.169A8.036 8.036 0 015.07 16h2.323c.212 1.023.505 1.96.865 2.77.06.136.123.269.188.399zm1.64-1.211A11.235 11.235 0 019.441 16h5.116a11.238 11.238 0 01-.643 1.958c-.328.738-.693 1.273-1.047 1.61-.35.333-.641.432-.868.432-.227 0-.518-.1-.868-.432-.354-.337-.719-.872-1.047-1.61zm5.656.812c.36-.81.653-1.747.865-2.77h2.323a8.036 8.036 0 01-3.376 3.169c.065-.13.128-.263.188-.399z","fill":"currentColor"}})])
          )
        }
      }
    